<template>
  <section class="section-pay w-full max-w-[1600px] mx-auto px-140 flex justify-between min-h-607 pt-150 pb-150">
    <div class="section-pay-left text-left mr-100 w-1/2">
      <p class="text-1xl text-black mb-20">{{$t('lang.pay1')}}</p>
      <p class="text-black mb-10 font-bold" style="font-size: 45px;">{{$t('lang.pay2')}}</p>
      <p class="mb-80 text-[#FF7800] font-[500]" style="font-size: 22px;">
        <span class="text-2xl mr-5 font-bold">——</span> {{$t('lang.pay3')}}
      </p>
      <p class="text-sm text-black">{{$t('lang.pay4')}}</p>

      <div class="mt-40">
        <div class="flex w-500 items-top mb-30">
          <div class="w-8 h-8 bg-[#FF7800] rounded-full mr-10 mt-5"></div>
          <p
            class="text-sm text-black ml-10 w-full word-break"
          >{{$t('lang.pay5')}}</p>
        </div>
        <div class="flex w-500 items-top mb-30">
          <div class="w-8 h-8 bg-[#FF7800] rounded-full mr-10 mt-5"></div>
          <p
            class="text-sm text-black ml-10 w-full word-break"
          >{{$t('lang.pay6')}}</p>
        </div>
      </div>
    </div>
    <div class="section-pay-right w-1/2">
      <img src="../assets/home_15_1.png" alt="changjing" class="w-full h-500 object-scale-down" />
    </div>
  </section>
</template>

<script>
export default {
  name: "sectionPay",

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>



<style lang="less" scoped>

</style>